import List from "./List";
import Detail from "./Detail";

const Proposal = {
    List,
    Detail
}

export default Proposal;